import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/store'
import SideMenu from './components/(admin)/SideMenu'
import TopBar from './components/(admin)/TopBar'
import ProtectedRoute from './components/(admin)/ProtectedRoute'
import Login from '././(auth)/Login'
import Signup from '././(auth)/Signup'
import Dashboard from '././(app)/Dashboard'
import UsageReports from '././(app)/UsageReports'
import CustomerManagement from '././(app)/CustomerManagement'
import BillingManagement from '././(app)/BillingManagement'
import BillingDetails from '././(app)/BillingDetails'
import './App.css'

function AppLayout({ children, isSidebarOpen, handleSidebarToggle }) {
  return (
    <div className="app-container">
      <SideMenu isOpen={isSidebarOpen} />
      <main className={`main-content ${!isSidebarOpen ? 'main-content-full' : ''}`}>
        <TopBar onSidebarToggle={handleSidebarToggle} isSidebarOpen={isSidebarOpen} />
        <div className="page-wrapper">
          {children}
        </div>
      </main>
    </div>
  )
}

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Navigate to="/dashboard" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout isSidebarOpen={isSidebarOpen} handleSidebarToggle={handleSidebarToggle}>
                  <Dashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/usage-reports"
            element={
              <ProtectedRoute>
                <AppLayout isSidebarOpen={isSidebarOpen} handleSidebarToggle={handleSidebarToggle}>
                  <UsageReports />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-management"
            element={
              <ProtectedRoute>
                <AppLayout isSidebarOpen={isSidebarOpen} handleSidebarToggle={handleSidebarToggle}>
                  <CustomerManagement />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing-management"
            element={
              <ProtectedRoute>
                <AppLayout isSidebarOpen={isSidebarOpen} handleSidebarToggle={handleSidebarToggle}>
                  <BillingManagement />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing-details/:userId"
            element={
              <ProtectedRoute>
                <AppLayout isSidebarOpen={isSidebarOpen} handleSidebarToggle={handleSidebarToggle}>
                  <BillingDetails />
                </AppLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </Provider>
  )
}

export default App
